import {default as attach} from '@lib/App';
import {
    PageAdapterOptions,
    registerPageAdapter,
} from '@src/lib/utils/pageAdapter';
import AppComponent from './app';

(async () => {
    const options: PageAdapterOptions = {
        // 开启主题适配，主题色会动态替换
        openThemeAdapter: true,
        // 开启字体Css变量，字体大小可使用变量
        openFontAdapter: true,
    };
    await registerPageAdapter(options);
    // @ts-ignore
    attach(AppComponent, '#app');
})();
